/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SingleTurnChatLanguageEnum } from './SingleTurnChatLanguageEnum';
import {
  SingleTurnChatLanguageEnumFromJSON,
  SingleTurnChatLanguageEnumFromJSONTyped,
  SingleTurnChatLanguageEnumToJSON,
} from './SingleTurnChatLanguageEnum';
import type { SingleTurnChatProtocolEnum } from './SingleTurnChatProtocolEnum';
import {
  SingleTurnChatProtocolEnumFromJSON,
  SingleTurnChatProtocolEnumFromJSONTyped,
  SingleTurnChatProtocolEnumToJSON,
} from './SingleTurnChatProtocolEnum';

/**
 *
 * @export
 * @interface SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerCustomApiCreate
 */
export interface SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerCustomApiCreate {
  /**
   *
   * @type {SingleTurnChatProtocolEnum}
   * @memberof SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerCustomApiCreate
   */
  protocol: SingleTurnChatProtocolEnum;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerCustomApiCreate
   */
  credentialValue?: string | null;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerCustomApiCreate
   */
  name: string;
  /**
   *
   * @type {SingleTurnChatLanguageEnum}
   * @memberof SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerCustomApiCreate
   */
  language: SingleTurnChatLanguageEnum;
  /**
   *
   * @type {Date}
   * @memberof SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerCustomApiCreate
   */
  timestamp?: Date;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerCustomApiCreate
   */
  endpointUrl: string;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerCustomApiCreate
   */
  method: string;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerCustomApiCreate
   */
  requestTemplate: string;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerCustomApiCreate
   */
  responsePaths: { [key: string]: string };
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerCustomApiCreate
   */
  otherHeaders?: { [key: string]: string } | null;
  /**
   *
   * @type {number}
   * @memberof SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerCustomApiCreate
   */
  credentialId?: number | null;
}

/**
 * Check if a given object implements the SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerCustomApiCreate interface.
 */
export function instanceOfSingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerCustomApiCreate(
  value: object,
): value is SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerCustomApiCreate {
  if (!('protocol' in value) || value['protocol'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('language' in value) || value['language'] === undefined) return false;
  if (!('endpointUrl' in value) || value['endpointUrl'] === undefined) return false;
  if (!('method' in value) || value['method'] === undefined) return false;
  if (!('requestTemplate' in value) || value['requestTemplate'] === undefined) return false;
  if (!('responsePaths' in value) || value['responsePaths'] === undefined) return false;
  return true;
}

export function SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerCustomApiCreateFromJSON(
  json: any,
): SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerCustomApiCreate {
  return SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerCustomApiCreateFromJSONTyped(json, false);
}

export function SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerCustomApiCreateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerCustomApiCreate {
  if (json == null) {
    return json;
  }
  return {
    protocol: SingleTurnChatProtocolEnumFromJSON(json['protocol']),
    credentialValue: json['credential_value'] == null ? undefined : json['credential_value'],
    name: json['name'],
    language: SingleTurnChatLanguageEnumFromJSON(json['language']),
    timestamp: json['timestamp'] == null ? undefined : new Date(json['timestamp']),
    endpointUrl: json['endpoint_url'],
    method: json['method'],
    requestTemplate: json['request_template'],
    responsePaths: json['response_paths'],
    otherHeaders: json['other_headers'] == null ? undefined : json['other_headers'],
    credentialId: json['credential_id'] == null ? undefined : json['credential_id'],
  };
}

export function SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerCustomApiCreateToJSON(
  value?: SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerCustomApiCreate | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    protocol: SingleTurnChatProtocolEnumToJSON(value['protocol']),
    credential_value: value['credentialValue'],
    name: value['name'],
    language: SingleTurnChatLanguageEnumToJSON(value['language']),
    timestamp: value['timestamp'] == null ? undefined : value['timestamp'].toISOString(),
    endpoint_url: value['endpointUrl'],
    method: value['method'],
    request_template: value['requestTemplate'],
    response_paths: value['responsePaths'],
    other_headers: value['otherHeaders'],
    credential_id: value['credentialId'],
  };
}
